import React from 'react';
import { Coords } from 'google-map-react';
import Button from '@mui/material/Button';
import { makeStyles } from 'tss-react/mui';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { useIntl } from 'ha/i18n';
import { units } from '@hbf/dsl';
import { LoadableGoogleMap } from 'ha/modules/GoogleMap';

import { ListingMapMarker } from 'ha/components.legacy/Listing/ListingMapMarker';
import { ListingMapErrorBoundary } from 'ha/components.legacy/Listing/ListingMapErrorBoundary';
import { INITIAL_MAP_ZOOM } from '../constants';

interface Props {
  coordinates: Coords;
  dragging?: boolean;
  fullscreenButton?: boolean;
  scrollwheel?: boolean;
  touchZoom?: boolean;
  doubleClickZoom?: boolean;
  boxZoom?: boolean;
  scrollWheelZoom?: boolean;
  tap?: boolean;
  zoomControl?: boolean;
  toggleFullscreenMap: () => void;
}

const useStyles = makeStyles()(theme => ({
  leftIcon: {
    color: theme.palette.grey[700],
    fontSize: units.rem(1.5),
    marginRight: units.rem(0.3),
  },
  fullscreenButton: {
    background: theme.palette.common.white,
    color: theme.palette.grey[700],
    fontWeight: 'bold',
    margin: units.rem(0.625),
    position: 'absolute',
    top: '0',
    left: '0',
  },
}));

export const ListingMap: React.FC<Props> = ({
  toggleFullscreenMap,
  coordinates,
  scrollwheel = false,
  fullscreenButton = false,
  dragging = true,
  touchZoom = false,
  doubleClickZoom = false,
  boxZoom = false,
  scrollWheelZoom = false,
  tap = false,
  zoomControl = true,
}) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  return (
    <React.Fragment>
      <ListingMapErrorBoundary>
        <LoadableGoogleMap
          center={coordinates}
          options={{
            scrollwheel,
            dragging,
            touchZoom,
            doubleClickZoom,
            boxZoom,
            scrollWheelZoom,
            tap,
            zoomControl,
          }}
          zoom={INITIAL_MAP_ZOOM}
        >
          <ListingMapMarker lat={coordinates.lat} lng={coordinates.lng} />
        </LoadableGoogleMap>
      </ListingMapErrorBoundary>
      {fullscreenButton && (
        <Button
          variant="contained"
          size="small"
          disableRipple
          className={classes.fullscreenButton}
          onClick={toggleFullscreenMap}
        >
          <FullscreenIcon className={classes.leftIcon} />
          {T('Open map')}
        </Button>
      )}
    </React.Fragment>
  );
};
